// extracted by mini-css-extract-plugin
module.exports = {"label":"FormResetPassword_label__qQ3Ak","submit":"FormResetPassword_submit__6Ihll","rotation":"FormResetPassword_rotation__XRq_p"};